<!--  -->
<template>
  <div class="package" :class="{ active: !showMore, disaled: packageCourse.status <= 4||packageCourse.status === 6 }">
    <div class="package-title" @click="openMore">
      <h2>
        <span></span><b class="ellipsis">{{ packageCourse.name }}</b>
      </h2>
      <!-- <van-icon name="arrow-up" /> -->
      <van-icon :name="showMore ? 'arrow-up' : 'arrow-down'"></van-icon>
    </div>
    <!-- 必选产品 -->
    <div class="mandatory">
      <PackageCourseCard
        v-for="(item, index) in mandatoryCourse"
        :courseInfo="item"
        :key="index"
        @skuInfo="skuInfo"
      />
    </div>
    <!-- 分组区域 -->
    <div class="optional" v-for="(child, index) in optionCourse" :key="index">
      <div class="group-name">
        <p>{{ child.groupInfo.name }}</p>
        <span>以下课程任选{{ child.groupInfo.selectProductNum }}个</span>
      </div>
      <ul class="optional-course">
        <li
          :class="{
            active: item.isSelect,
            disbaled: (child.disbaled && !item.isSelect) || item.disaled,
          }"
          v-for="(item, idx) in child.productSkuList"
          :key="idx"
          @click="chooseCourse(item, index, idx)"
        >
          <p class="ellipsis">
            {{ item.name }}
          </p>
          <img :src="checkIcon" alt="" />
          <span>{{ String(item.skuName) }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';
import PackageCourseCard from './packageCourseCard.vue';

export default {
  components: {
    PackageCourseCard,
  },
  data() {
    return {
      checkIcon,
      showMore: false,
      mandatoryCourse: [], // 必选课程
      optionCourse: [], // 可选课程
    };
  },
  props: {
    packageCourse: {
      type: Object,
      default: () => {},
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  watch: {},
  methods: {
    initData() {
      // packageProductOptionList: 必选
      // packageGroupOptionList
      const { packageProductOptionList, packageId, packageGroupOptionList } = this.packageCourse;
      (packageProductOptionList || []).forEach((item) => {
        Object.assign(item, { packageId, itemType: 1 });
      });

      this.mandatoryCourse = packageProductOptionList || [];
      const courses = [];
      (packageGroupOptionList || []).forEach((element) => {
        const {
          groupId, groupProductNum, name, selectProductNum,
        } = element;
        const productSkuList = [];
        const groupInfo = {};
        Object.assign(groupInfo, {
          groupId,
          groupProductNum,
          name,
          selectProductNum,
          num: 0,
          itemType: 2,
        });
        element.packageProductOptionList.forEach((course) => {
          const {
            isBuy, isExpire, isSoldOut, isOffline,
          } = course;
          course.productSkuOptions.forEach((child) => {
            const skuSpecJson = JSON.parse(child.specJson);
            productSkuList.push({
              packageGroupId: groupId,
              packageGroupName: name,
              packageGroupSelectProductNum: selectProductNum,
              packageId: this.packageCourse.packageId,
              name: course.productName,
              productId: course.productId,
              productSkuId: child.productSkuId,
              skuName: child.isDefault ? [] : skuSpecJson.map((item) => item.value),
              isSelect: false,
              disaled:
                isBuy
                || isExpire
                || isSoldOut
                || isOffline
                || !((child.isSetStock === 1 && child.availableStock) || child.isSetStock === 0),
              itemType: 2,
            });
          });
        });
        courses.push({ productSkuList, groupInfo });
      });
      this.optionCourse = courses;
    },
    openMore() {
      this.showMore = !this.showMore;
    },
    skuInfo(data) {
      const { selectSkuInfo } = data;
      this.mandatoryCourse.forEach((item) => {
        if (item.productId === data.productId) {
          Object.assign(item, {
            productSkuId: selectSkuInfo.productSkuId,
          });
        }
      });
      this.handleParams();
    },
    chooseCourse(course, index, idx) {
      this.optionCourse[index].productSkuList[idx].isSelect = !course.isSelect;
      let num = 0;
      this.optionCourse.forEach((item) => {
        item.productSkuList.forEach((child) => {
          // 同产品不同sku 互斥
          if (
            child.isSelect
            && child.productId === course.productId
            && child.productSkuId !== course.productSkuId
          ) {
            Object.assign(child, { isSelect: false });
          }
        });
        // 当前组超过可选数量置灰
        num = item.productSkuList.filter((child) => child.isSelect).length;
        Object.assign(item, { disbaled: item.groupInfo.selectProductNum === num });
        Object.assign(item, {
          groupSlectedCourse: item.productSkuList.filter((child) => child.isSelect),
        });
      });
      this.handleParams();
    },
    // 检查分组产品是否都已按照规定选择
    handleParams() {
      const { mandatoryCourse, optionCourse } = this;
      Object.assign(this.packageCourse, { mandatoryCourse, optionCourse });
      this.$emit('receivePackageCourse', this.packageCourse);
    },
  },
  created() {},
  mounted() {
    this.initData();
    this.showMore = !this.isOpen;
  },
};
</script>
<style lang="scss" scoped>
.package {
  height: 120px;
  padding: 0 40px;
  overflow: hidden;
  border-bottom: 20px solid #f9f9f9;
  .package-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px 0;
    cursor: pointer;
    h2 {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        width: 8px;
        height: 40px;
        background: linear-gradient(180deg, #ffae74 0%, #ff6c02 100%);
        border-radius: 4px;
      }
      b {
        display: block;
        width: 500px;
        padding-left: 10px;
        color: #333;
        font-weight: 500;
        font-size: 36px;
      }
    }
    i {
      color: #999;
      font-size: 30px;
    }
  }
  .mandatory {
    margin-bottom: 24px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f5f5f6;
  }
  .optional {
    // padding: 40px;
    .group-name {
      // height: 100px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-start;
      padding-bottom: 32px;
      p {
        width: 100%;
        padding: 0 0 12px 0;
        color: #333;
        font-weight: 400;
        font-size: 32px;
        line-height: 44px;
      }
      span {
        color: #999;
        font-weight: 400;
        font-size: 24px;
        line-height: 40px;
      }
    }
    .optional-course {
      li {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-start;
        width: 670px;
        // height: 105px;
        margin-bottom: 24px;
        padding: 22px 10px;
        background: #fff;
        border: 2px solid #e8e8e8;
        border-radius: 4px;
        p {
          width: 100%;
          color: #333;
          font-weight: 400;
          font-size: 28px;
        }
        span {
          padding-top: 5px;
          color: #787878;
          font-size: 24px;
        }
        img {
          display: none;
        }
      }
      li.disbaled {
        background: #f9f9f9;
        // opacity: 0.5;
        pointer-events: none;
        p,
        span {
          color: #c8c8c8;
        }
      }
      li.active {
        background: #fff5ed;
        border: 2px solid #ff6c02;
        border-radius: 4px;
        img {
          position: absolute;
          right: 0;
          bottom: -1px;
          display: block;
          width: 29px;
        }
        p,
        span {
          color: #ff6c02;
        }
      }
    }
  }
}
// 套餐展开
.package.active {
  height: auto;
}
// 套餐下架/过期
.package.disaled {
  ::v-deep .select-card.isSingle {
    background: #fafafa;
    border: 1px solid #e8e8e8;
    pointer-events: none;
    .name,
    h3,
    span {
      color: #c8c8c8;
    }
  }
  ::v-deep .select-card {
    span {
      color: #c8c8c8;
    }
    p {
      background: #fafafa !important;
      border: 1px solid #e8e8e8 !important;
      pointer-events: none;
    }
    img {
      display: none !important;
    }
  }
  .optional{
    .optional-course{
      li{
        background: #fafafa;
        pointer-events: none;
        p,span{
          color: #c8c8c8;
        }
      }
    }
  }
}
</style>
